import { ReactElement, useState } from 'react';
import { WaterOverviewInfo } from 'providers/types/api-private';
import { WaterGraph } from './components/Graph';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { CardsGraphContainer, DetailsButton, WaterCardContainer } from '../styles';
import { TitleGraph } from '~/pages/NewOverview/styles';
import { useFilterContext } from '~/pages/NewOverview/contexts/FilterContext';
import { handleFilterStateRoute } from '~/pages/NewOverview/helpers/filters';

interface WaterCardContentProps {
  data: WaterOverviewInfo | undefined;
  expanded: boolean;
}

export function WaterCardContent({
  data,
  expanded,
}: Readonly<WaterCardContentProps>): ReactElement {
  const [profile] = useState(getUserProfile);
  const { t } = useTranslation();
  const { selectedOptions, client } = useFilterContext();
  const history = useHistory();

  function onClickDetails(): void {
    history.push('/analise/utilitarios?dispositivo=agua',
      handleFilterStateRoute(client, selectedOptions, profile));
  }

  return (
    <WaterCardContainer expanded={expanded}>
      <TitleGraph>{t('consumoAgua')}</TitleGraph>
      <CardsGraphContainer>
        <WaterGraph data={data} expanded={expanded} />
        {data && (
          <DetailsButton
            type="button"
            variant="primary-ghost"
            onClick={onClickDetails}
          >
            {t('verDetalhes')}
          </DetailsButton>
        )}
      </CardsGraphContainer>
    </WaterCardContainer>
  );
}
